import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { DeviceUtilsService } from '../../shared/services/device-utils.service';
import * as fromDeviceActions from './actions';

@Injectable()
export class DeviceEffects {
  isMobilebreakpointChanged$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(fromDeviceActions.isMobileChanged),
        tap(({ isMobile }) => {
          return this.deviceUtilsService.breakpointChanged(isMobile);
        }),
      );
    },
    { dispatch: false },
  );

  constructor(private readonly actions: Actions, private readonly deviceUtilsService: DeviceUtilsService) {}
}
